export enum WaitingChargeStatus {
    Free = 'FREE',
    Hourly = 'HOURLY',
    Daily = 'DAILY',
}